import React, { ChangeEvent } from 'react'
import { useField } from 'formik'
import { CountryDropdownItem, CountrySelect } from './CountriesDropdownBase'
import { isInvalid } from './utils'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface CountryDropdownProps extends Omit<React.ComponentProps<typeof CountrySelect>, 'value' | 'onChange'> {
  helperText?: string
  onChange?: (value: CountryDropdownItem) => void
}

export const CountriesDropdownFormik: React.FC<CountryDropdownProps> = ({ name, helperText, onChange, ...rest }) => {
  const [input, meta, helpers] = useField<string>({ name })

  useRegisterFormField(name)

  const handleOnchange = (_: ChangeEvent<{}>, value: CountryDropdownItem | null) => {
    if (value) {
      helpers.setValue(value.value)
      onChange && onChange(value)
    }
  }

  return (
    <CountrySelect
      onChange={handleOnchange}
      value={input.value}
      name={input.name}
      textFieldInputProps={{ error: isInvalid(meta), helperText: isInvalid(meta) ? meta.error : helperText }}
      {...rest}
    />
  )
}
